// extracted by mini-css-extract-plugin
export default {"tabs":"MXPlHuN9wT","icon":"_4+WeT7IfeC","divider":"qoXvg-UDJC"};